<div class="adminWidgetSidebar-container" [class.open]="isOpen" [ngClass]="customClass">
  <div class="adminWidgetWrapper">
    <button class="toggleBtn" [class.toggleBtnActive]="isOpen" (click)="toggleSidebar()"
      [attr.aria-label]="isOpen ? 'Close widget sidebar' : 'Open widget sidebar'" type="button">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <div class="adminWidgetSidebar-contentWrapper">
      <div class="titleWrapper">
        <mat-icon>settings</mat-icon>
        <h2 class="title">Admin Widget</h2>
      </div>
      <div class="itemList">
     

        <div class="item" *ngIf="!isSecretCodeValidated">
          <h3 class="itemTitle">Enter Secret Code</h3>
          <mat-form-field appearance="outline" class="myMatFormField mb-0" subscriptSizing="dynamic">
            <input matInput placeholder="Enter Secret Code" [(ngModel)]="secretCode" type="text" required
              aria-label="Please enter secret code. This is a required field.">
            <mat-error>
              Secret Code is required.
            </mat-error>
          </mat-form-field>
          <div>
            <ion-button class="primary-general-btn mb-0" mat-ripple [disabled]="!secretCode"
              (click)="validateSecretCode()">
              Validate Secret Code
            </ion-button>
          </div>
        </div>
        <div class="item settings-link-wrapper">
          <a href="javascript:void(0);" class="settings-link" (click)="openMockServerSettings()"
            [attr.aria-label]="'Open Mock Server settings'">
            <mat-icon>settings</mat-icon>
            View My Mock settings

          </a>
        </div>
       

        <div class="item" *ngIf="isSecretCodeValidated">
          <h3 class="itemTitle">
            Mock Server toggle
          </h3>
          <!-- <div class="toggle-switch-container">
            <input type="checkbox" id="mockServerToggle" class="toggle-switch-input" [(ngModel)]="mockServerEnabled"
              (change)="onMockServerChange($event)">
            <label for="mockServerToggle" class="toggle-switch-label">
              <span class="toggle-switch-slider"></span>
            </label>
          </div> -->
          <div class="toggle-container">
            <label class="toggle-label">
              Enable Mock Server
              <input type="checkbox" class="toggle-input" [(ngModel)]="mockServerEnabled"
                (change)="onMockServerChange($event)" aria-label="Enable Mock Server">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
        <ng-container *ngIf="mockServerEnabled && isSecretCodeValidated">
          <div class="item">
            <h3 class="itemTitle">Select Endpoint</h3>
            <mat-form-field appearance="outline" class="myMatFormField selectFormField mb-3" subscriptSizing="dynamic">
              <mat-select [(ngModel)]="selectedEndPoint" (selectionChange)="onEndpointSelectionChange($event)">
                <!-- Search Box -->
                <mat-option class="mat-select-search-option">
                  <div class="mat-select-search-container">
                    <input matInput type="text" class="mat-select-search-input" placeholder="Search endpoint..."
                      [(ngModel)]="endpointSearchText" (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()" />
                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                  </div>
                </mat-option>

                <!-- Filtered Options -->
                <mat-option class="endpointOptions" *ngFor="let item of filteredEndpoints()" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="item">
            <h3 class="itemTitle">
              Select Cases
            </h3>
            <ng-container *ngIf="testCases.length > 0; else noOptions">
              <mat-radio-group class="radio-group" [(ngModel)]="selectedCase" name="case">
                <mat-radio-button class="custom-radio" *ngFor="let case of testCases" [value]="case.value">
                  {{case.label}}
                </mat-radio-button>
              </mat-radio-group>
            </ng-container>
          </div>
          <ng-template #noOptions>
            <div class="no-options-message">No options to display</div>
          </ng-template>

          <div>
            <ion-button class="primary-general-btn" mat-ripple
              [disabled]="selectedEndPoint === null || selectedCase === ''"
              [ngClass]="{ 'button-disabled': selectedEndPoint===null || selectedCase=== '' }"
              (click)="saveSettings()">
              Save
            </ion-button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>